import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => (
  <div className="min-h-screen bg-[#07090D] text-white">
    <Header />
    <main className="min-h-[calc(100vh-76px)] bg-[#07090D] pt-[76px]">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default Layout;
